import * as React from "react";

const SvgLeftButton = (text) => (
  <svg
    width="55"
    height="55"
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.348267"
      y="0.453125"
      width="54"
      height="54"
      rx="27"
      fill="#E0E0E0"
    />
    <path
      d="M31.8483 17.4531L23.4503 26.7842C23.1081 27.1645 23.1081 27.7418 23.4503 28.1221L31.8483 37.4531"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgLeftButton;
